import * as Types from '../types';
import { Environment } from '../../../config';
import request from '../../../utils/request';

export interface FetchRemindersMsconReceivedListInput {
  sortField: string;
  page: number;
  pageSize: number;
  order: 'asc' | 'desc';
  vat_num?: string;
  originatingCountry?: string;
  schemeType?: string;
}

export interface RemindersMsconReceivedListElement {
  applicant_id: number;
  vat_number: string;
  is_sent: boolean;
  type: string;
  reminded_date: Date;
}

export interface RemindersMsconReceivedListData {
  paging: RemindersMsconReceivedListPaging;
  items: RemindersMsconReceivedListElement[];
}

export interface RemindersMsconReceivedListPaging {
  page: number;
  pageSize: number;
  total: number;
}

export const fetchRemindersMsconReceivedList = async (
  payload: FetchRemindersMsconReceivedListInput
): Promise<Types.ResponseOutput> => {
  let searchQuery = '';
  if (payload.vat_num) searchQuery += `&vat_num=${payload.vat_num}`;
  if (payload.originatingCountry)
    searchQuery += `&originatingCountry=${payload.originatingCountry}`;
  if (payload.schemeType) searchQuery += `&schemeType=${payload.schemeType}`;
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/payment-reminder-received/list?page=${payload.page}&pageSize=${payload.pageSize}&sortField=${payload.sortField}&order=${payload.order}&reminderType=MSCON${searchQuery}`
  );

  let _data: RemindersMsconReceivedListData = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

export interface FetchRemindersMsidReceivedListInput {
  sortField: string;
  page: number;
  pageSize: number;
  order: 'asc' | 'desc';
  vat_num?: string;
  originatingCountry?: string;
  schemeType?: string;
}

export interface RemindersMsidReceivedListElement {
  applicant_id: number;
  vat_number: string;
  is_sent: boolean;
  type: string;
  reminded_date: Date;
}

export interface RemindersMsidReceivedListData {
  paging: RemindersMsidReceivedListPaging;
  items: RemindersMsidReceivedListElement[];
}

export interface RemindersMsidReceivedListPaging {
  page: number;
  pageSize: number;
  total: number;
}

export const fetchRemindersMsidReceivedList = async (
  payload: FetchRemindersMsidReceivedListInput
): Promise<Types.ResponseOutput> => {
  let searchQuery = '';
  if (payload.vat_num) searchQuery += `&vat_num=${payload.vat_num}`;
  if (payload.originatingCountry) {
    searchQuery += `&originatingCountry=${payload.originatingCountry}`;
  }
  if (payload.schemeType) searchQuery += `&schemeType=${payload.schemeType}`;
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/payment-reminder-received/list?page=${payload.page}&pageSize=${payload.pageSize}&sortField=${payload.sortField}&order=${payload.order}&reminderType=MSID${searchQuery}`
  );

  let _data: RemindersMsidReceivedListData = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};
